import DefaultNewsCard from './Default'
import SmallNewsCard from './Small'
import SplitNewsCard from './Split'

export { DefaultNewsCard, SmallNewsCard, SplitNewsCard }
export default DefaultNewsCard
